// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "patientDashboard." + ({"138":"profile","147":"app-routes","251":"checkout","352":"onboarding"}[chunkId] || chunkId) + "." + {"138":"385d1cdd7ae869682c57","147":"07fe8511d2c79bb960bd","251":"27569ea7f61f7635b828","352":"d976b336ac09a5b14f0d","550":"b011e4abbc8967a4f77d"}[chunkId] + ".js";
};